/**
 * Generates a random Happy ID in the format `XXX-XXX`.
 * Each `X` is a digit between 0 and 9.
 *
 * @returns {string} The generated Happy ID.
 */
export const generateHappyId = () => {
    return Math.floor(Math.random() * (999 - 100 + 1) + 100) + "-" + Math.floor(Math.random() * (999 - 100 + 1) + 100);
};